import CustomJS from "../../../components/BuilderComponents/CustomJS";
import { useFormContext } from "../../../context/FormContext";

const InitalCustomJs = () => {
  const { formActvityData, setFormActivityData, selectedForm } = useFormContext();

  const handleCustomJSChange = (data) => {
    const copyActivityData = JSON.parse(JSON.stringify(formActvityData));
    copyActivityData.initial_custom_js = data;
    setFormActivityData(copyActivityData);
  };

  return (
    <div className="form_custom_function builder_form" style={{ height: "calc(100vh - 136px)" }}>
      <div>
        <div style={{ minHeight: "50vh" }}>
          <CustomJS
            inputString={formActvityData.initial_custom_js}
            handleChange={handleCustomJSChange}
            tableID={selectedForm.parentData.split("/")[0]}
            showFullScreenIcon={false}
            label="Initial Custom JS"
          />
        </div>
      </div>
    </div>
  );
};

export default InitalCustomJs;
